import { render, staticRenderFns } from "./PaymentDataModal.vue?vue&type=template&id=fba1a430&"
import script from "./PaymentDataModal.vue?vue&type=script&lang=js&"
export * from "./PaymentDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports